const url = process.env.VUE_APP_API_URL + "ending/games"

export default {
  namespaced: true,

  state: {
    records: [],
    loading: false,
    recordsPerGame: [],
    recordsPerGameLoading: false
  },
  mutations: {
    setRecords (state, val) {
      state.records = val
    },
    setRecordsLoading (state, val) {
      state.loading = val
    },
    setRecordsPerGame(state, val) {
      state.recordsPerGame = val
    },
    setRecordsPerGameLoading(state, val) {
      state.recordsPerGameLoading = val
    }
  },

  actions: {
    async getRecords({ commit, rootState }, data) {
      commit("setRecordsLoading", true)

      try {
        const response = await fetch(`${url}/card_reports?${data}` , {
          method: 'GET',
          headers: {
            'Authorization': `Bearer ${rootState.userToken}`,
          }
        })

        const res = await response.json()
        
        if (!response.ok) {
          throw { response, res }
        } else {
          commit("setRecords", res.records)

          return res
        }
      } catch(error) {
        const errorStatus = error.response.status
        
        if (errorStatus==401) {
          commit("setError", "Unauthorized", { root: true })
        } else {
          commit("setRefreshError", "Submitted invalid data", { root: true })
        }
      } finally {
        commit("setRecordsLoading", false)
      }
    },

    async getRecordsPerGame({ commit, rootState }, data) {
      commit("setRecordsPerGameLoading", true)

      try {
        const response = await fetch(`${url}/card_reports_per_game?${data}` , {
          method: 'GET',
          headers: {
            'Authorization': `Bearer ${rootState.userToken}`,
          }
        })

        const res = await response.json()
        
        if (!response.ok) {
          throw { response, res }
        } else {
          commit("setRecordsPerGame", res.records)

          return res
        }
      } catch(error) {
        const errorStatus = error.response.status
        
        if (errorStatus==401) {
          commit("setError", "Unauthorized", { root: true })
        } else {
          commit("setRefreshError", "Submitted invalid data", { root: true })
        }
      } finally {
        commit("setRecordsPerGameLoading", false)
      }
    }
  }
}